import classnames from "classnames/bind";
import Config from "config";
import React, { useEffect, useState } from "react";
import { CookiesProvider, useCookies } from "react-cookie";
import ReactDOM from "react-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import {
  after,
  copyObject,
  getApiDataAsync,
  getArea,
  getPathFromUrl,
  getPropertyType,
  getPropertyTypeEn,
  isMobile,
  kloader,
  postApiDataAsync,
  scrollToValue,
  showAreaValue,
  showBedAndBath,
  showUseableAreaValue,
  addQueryString,
  getQueryStringParameter,
} from "../common/Common";
import { DropLeadInputField, DropLeadSelectList } from "../common/Component";
import { HeaderWithSearch } from "../common/Header";
import { PropertyList, checkIsPartner } from "../common/PropertyBox";
import configureStore from "../store";
import {
  DropleadListChange,
  DropleadValidateChange,
  formsCalcDataChange,
  formsDropleadDataChange,
  searchResultDataChange,
  updatePropertyDetail,
  updateSearchResultList,
} from "../stores/propertySlice";
import { CalculatorsV2 } from "./calculatorsV2";
import { PartnerCalculator } from "./PartnerCalculator";
import { VaridateDropleadDataField, getAmount } from "./ValidateHelper";

import ReCAPTCHA from "react-google-recaptcha";

import moment from "moment";
import { LoginFooter } from "../common/LoginFooter";
import { auctionDetailLink } from "./auctionConstants";
import { Breadcrumbs } from "./Breadcrumbs";
import {
  AnnouncementText,
  DetailWrapper,
  PartnerDetail,
  PriceWrapper,
  PrivacyText,
  PropertyDetailsCondition,
  PropertyInfoTable,
  PropertyNearByTabList2024,
  PropertyRemark,
  ShareConent,
  TableDetail,
  TagBadgeWrapper,
  TagPropertiesWrapper,
  getLocation,
} from "./common";
import { GallerySlide } from "./GallerySlide";
import { HeadingWrapper } from "./HeadingWrapper";
import { IdeaDecoration } from "./IdeaDecoration";
import "./index.css";
import { MyGoogleMap } from "./NewGoogleMap";

const store = configureStore();

const mediaURLPrefix = Config.mediaURLPrefix;
const defaultThumbnailURL = Config.defaultThumbnailURL;
const $ = window.$;

const pagesLink = Config.pagesLink;
const placeTypes = Config.placeTypes;
const backendNPAURL = Config.backendNPAURL;
const ReCAPTCHASiteKey = Config.ReCAPTCHASiteKey;

const regexForReplace = Object.freeze({
  thaiEngWithSpace: /[^A-Za-z\u0E01-\u0E3A\u0E40-\u0E4D\s]/g,
  numberOnly: /[^0-9]/g,
  emojiRegEx:
    /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g,
});

function dmyHmsToDateObj(str) {
  var dateTimeParts = str.split("T");
  var dateParts = dateTimeParts[0].split("-");
  var timeParts = dateTimeParts[1].split(":");

  return new Date(
    +dateParts[0],
    +dateParts[1] - 1,
    +dateParts[2],
    +timeParts[0],
    +timeParts[1],
    +timeParts[2]
  );
}

const propertyForAuction = [
  "028807181",
  "028808438",
  "028811133",
  "028810424",
  "028811240",
  "038804499",
  "038805142",
  "038805197",
  "038804742",
  "038804259",
  "058801656",
  "058802203",
  "058802285",
  "058802295",
  "058802296",
  "038805536",
];
const auctionTime = [
  [
    dmyHmsToDateObj("2024-05-02T00:00:00"),
    dmyHmsToDateObj("2024-05-18T16:00:00"),
  ],
  [
    dmyHmsToDateObj("2024-04-28T00:00:00"),
    dmyHmsToDateObj("2024-04-30T23:00:00"),
  ], // for test
];

const currentlyInAuction = (propertyId) => {
  if (propertyForAuction.indexOf(propertyId) != -1) {
    var time = new Date();
    var result = null;
    auctionTime.some((range) => {
      return time >= range[0] && time < range[1]
        ? ((result = range), true)
        : false;
    });
    if (result) {
      return result;
    }
  }
  return false;
};

// axios.defaults.headers.common['Authorization'] = store.getState().Token;
//process.env.API_ROOT_URL

// distance = 10000

const PropertyGallery = React.memo((props) => {
  const [slideImages, setslideImages] = useState([]);

  const onLoad = after(slideImages.length * 3, () => {
    initPageJs();
  });

  const ReaderChild = (list, componentClassName) => {
    list = list.map((property, index) => {
      return (
        <div
          className="swiper-slide"
          key={`${componentClassName + property.MediaPath}`}
        >
          <div className={componentClassName}>
            <img
              id={`${componentClassName + property.MediaPath}`}
              src={mediaURLPrefix + property.MediaPath}
              onLoad={onLoad}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultThumbnailURL;
                currentTarget.setAttribute("test", "test");
                onLoad();
              }}
              alt={`${props.propertyName} ${index + 1}`}
              loading="lazy"
            />
          </div>
        </div>
      );
    });
    return list;
  };

  useEffect(() => {
    if (props.list && props.list.length > 0) {
      var imageTypes;

      if (isMobile()) {
        imageTypes = ["IMAGE-MOBILE", "MAP-MOBILE"];
      } else {
        imageTypes = ["IMAGE-PC", "MAP-PC"];
      }

      setslideImages(
        props.list
          .filter(function (media) {
            return imageTypes.indexOf(media.MediaType) !== -1;
          })
          .sort(function (a, b) {
            if (a.MediaType < b.MediaType || a.MediaPath < b.MediaPath) {
              return -1;
            } else if (a.MediaType > b.MediaType || a.MediaPath > b.MediaPath) {
              return 1;
            } else {
              return 0;
            }
          })
      );
    }
  }, [props.list]);
  console.log("PropertyGallery Render len:", slideImages.length);
  if (slideImages.length > 0) {
    return (
      <>
        <section id="property-gallery" className="gallery-container">
          <div className="swiper gallery-swiper">
            <div className="swiper-wrapper">
              {ReaderChild(slideImages, "gallery-img")}
            </div>

            <div
              title="Next"
              className="slick-bt-next swiper-button-next next-btn"
            ></div>
            <div
              title="Previous"
              className="slick-bt-back swiper-button-prev prev-btn"
            ></div>

            <button
              type="button"
              name="more-gallery"
              className="more-gallery-btn"
            >
              <i className="ic-npa ic-npa-icon-gallery"></i>
              <span className="d-none d-md-block">ดูรูปทั้งหมด</span>
            </button>
          </div>
          <div className="swiper gallery-sm-swiper">
            <div className="swiper-wrapper">
              {ReaderChild(slideImages, "gallery-sm-img")}
              <div className="swiper-slide">
                <a
                  href={void 0}
                  className="pxtm-click-navMenu hidden-lg mousePointer"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#contact-offcanvas"
                  aria-controls="contact-offcanvas"
                >
                  <div className="gallery-sm-more">
                    <i className="ic-npa ic-npa-icon-contact"></i>
                    <p>
                      นัดหมาย
                      <br />
                      เข้าชมทรัพย์
                    </p>
                  </div>
                </a>

                <a
                  href={void 0}
                  onClick={() => scrollToValue($("#property-gallery").height())}
                  className="pxtm-click-navMenu gallery-sm-more show-lg mousePointer"
                >
                  <i className="ic-npa ic-npa-icon-contact"></i>
                  <p>
                    นัดหมาย
                    <br />
                    เข้าชมทรัพย์
                  </p>
                </a>
              </div>
            </div>
            <div className="swiper-pagination scroll-pagi gallery-sm-pagi"></div>
          </div>
        </section>
        <div id="gallery-modal" className="gallery-backdrop">
          <div
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            className="swiper-container gallery-modal-swiper"
          >
            <div className="swiper-wrapper">
              {ReaderChild(slideImages, "swiper-zoom-container")}
            </div>
            <div
              title="Next"
              className="slick-bt-next swiper-button-next next-btn"
            ></div>
            <div
              title="Previous"
              className="slick-bt-back swiper-button-prev prev-btn"
            ></div>
            <div className="swiper-pagination fraction"></div>
            <button type="button" className="close-gallery-modal">
              <img
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
                alt=""
              />
            </button>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}, areSlideImagesEqual);

function areSlideImagesEqual(prevProps, nextProps) {
  if (prevProps.list?.length !== nextProps.list?.length) {
    return false;
  }
  return true;
}

const DetailPage = () => {
  const [propertyDetail, isLike, calcDetail, dropleadDetail, searchFilter] =
    useSelector((state) => [
      state.property.propertyDetail,
      state.property.propertyDetail.Like,
      state.property.calcDetail,
      state.property.dropleadDetail,
      state.property.searchFilter,
    ]);

  const closePageStartTime = dmyHmsToDateObj("2023-12-14T17:00:00");
  const closePageEndTime = dmyHmsToDateObj("2023-12-15T08:00:00");

  const [enableOfferLink, setEnableOfferLink] = useState(true);
  const [enableDropleadLink, setEnableDropleadLink] = useState(true);

  const [isAuction, setIsAuction] = useState(false);

  useEffect(() => {
    var currentTime = new Date();

    if (currentTime >= closePageStartTime && currentTime < closePageEndTime) {
      setEnableOfferLink(false);
      //setEnableDropleadLink(false);
    }
  }, []);

  useEffect(() => {
    if (propertyDetail.PropertyID) {
      setIsAuction(currentlyInAuction(propertyDetail.PropertyID));
    }
  }, [propertyDetail.PropertyID]);

  const [showNaCitizenId, setShowNaCitizenId] = useState(false);
  const [hasCustomerInfo, setHasCustomerInfo] = useState(false);
  const [fbNpaList, setFbNpaList] = useState({});

  const [showMobileMap, setShowMobileMap] = useState(false);

  const recaptchaRef = React.createRef();

  const dispatch = useDispatch();
  const [cookies, setCookie] = useCookies();

  let tempDataDetail = {
    AssetInfoTH: "",
    AddressNoTH: "",
    BuildingTH: "",
    FloorTH: "",
    VillageTH: "",
    SoiTH: "",
    RoadTH: "",
    TambonName: "",
    AmphurName: "",
    ProvinceName: "",
    location: "",
    PropertyTypeName: "",
    Bedroom: "",
    Bathroom: "",
    SellPrice: "",
    PromotionPrice: "",
    AdjustPrice: "",
    PromotionName: "",
    PromotionRemark: "",
    PropertyIDFormat: "",
    PropertyID: "",
    Area: "",
    AreaValue: "",
    UseableArea: "",
    PropertyMediaes: "",
    GAScore: "",
    GaCountView: "",
    Like: "",
    IsNew: "",
    CategoryGroup: "",
  };

  function getValue(value) {
    return value && value !== "-" ? value : "";
  }

  function makeAnOfferClick() {
    if (!enableOfferLink) {
      enablePageLink();
      return;
    }
    kloader();
    makeAnOffer();
    return;

    //open pop up
    $("#confirm-data-modal").css({
      display: "flex",
    });
  }

  function enablePageLink() {
    var m = moment(closePageEndTime).locale("th");
    const closePopUpText = `ขออภัย<br />เนื่องจากธนาคารกสิกรไทยอยู่ในระหว่างปรับปรุงระบบ มีผลทำให้ไม่สามารถใช้งานได้ ท่านสามารถใช้งานได้อีกครั้งวันที่ ${m.format(
      "LLL"
    )}น. ขออภัยในความไม่สะดวก`;
    openErrorPopup(closePopUpText);
  }

  function makeAnOffer() {
    if (propertyDetail.PropertyID) {
      const leadby = getQueryStringParameter("leadby");

      const queryParams = {
        propID: propertyDetail.PropertyID,
        PropertyIDFormat: propertyDetail.PropertyIDFormat,
        PropertyTypeName: propertyDetail.PropertyTypeName,
        ...(leadby && { leadby: leadby }),
      };

      const queryString = addQueryString(queryParams);

      const urlWithQuery = `${pagesLink.offer}${queryString}`;

      window.open(urlWithQuery, "_self");

      // window.open(
      //   pagesLink.offer +
      //     `?propID=${propertyDetail.PropertyID}&PropertyIDFormat=${propertyDetail.PropertyIDFormat}&PropertyTypeName=${propertyDetail.PropertyTypeName}`,
      //   "_self"
      // );
    } else {
      console.log("Not found PropertyID (makeAnOffer)");
    }
  }

  function cancelMakeAnOffer() {
    $("#confirm-data-modal").css({
      display: "",
    });
  }

  function likeThisProperty() {
    var temp = JSON.parse(JSON.stringify(propertyDetail));
    temp.Like = !temp.Like;
    dispatch(updatePropertyDetail({ value: temp }));
  }

  function getNearByPlaceByGroupCode(TypeCode, placeList) {
    return placeList.filter((x) => x.PlaceType === TypeCode);
  }

  function genNearByPlaces(NearbyPlaces) {
    let placeTypesList = copyObject(placeTypes);

    placeTypesList.map((group) => {
      if (typeof group.TypeCode !== "string") {
        group.places = [];
        group.TypeCode.forEach((TypeCode) => {
          group.places = group.places.concat(
            getNearByPlaceByGroupCode(TypeCode, NearbyPlaces)
          );
        });
      } else {
        group.places = getNearByPlaceByGroupCode(group.TypeCode, NearbyPlaces);
      }
    });

    // get only 4
    placeTypesList = placeTypesList.filter((x) => x.places.length).slice(0, 4);

    // Sort Distance Asc
    placeTypesList.forEach((x) => {
      x.places = x.places.sort((a, b) => a.Distance - b.Distance);
    });
    return placeTypesList;
  }

  function dropleadDataChange(field, value) {
    let errorMessage = "";
    switch (field) {
      case "naSalary":
        const limit = 1000000000;
        let tempValue = parseFloat(value.replace(/,/g, ""));
        tempValue = tempValue > limit ? limit : tempValue;
        if (tempValue || tempValue === 0) {
          value = tempValue.toLocaleString();
        } else {
          value = "";
        }
        break;
      case "juJuristicId":
        value = value.replace(regexForReplace.numberOnly, "");
        value = value.slice(0, 13);
        break;
      case "phone":
      case "confirmphone":
        value = value.replace(regexForReplace.numberOnly, "");
        value = value.slice(0, 10);
        break;
      // case 'select':
      case "availableTime":
      case "naCareer":
        errorMessage = VaridateDropleadDataField(dropleadDetail, field, value);
        break;
      default:
        break;
    }
    console.log("on change", field, value, errorMessage);
    dispatch(formsDropleadDataChange({ field, value, errorMessage }));
  }

  function dropleadBlur(field, value) {
    console.log(field, value);

    const errorMessage = VaridateDropleadDataField(
      dropleadDetail,
      field,
      value
    );

    dispatch(formsDropleadDataChange({ field, value, errorMessage }));
    if (!errorMessage && value && dropleadDetail.usertype.value !== "ju") {
      let validateField = ["phone", "confirmphone", "email"];
      validateField = validateField.filter((x) => x !== field);
      const validates = validateField.map((field) => {
        const result =
          dropleadDetail[field].value && !dropleadDetail[field].errorMessage;
        return result;
      });
      const valid = validates.every((c) => c);

      setShowNaCitizenId(valid);
    }
  }

  function dropLeadDraft() {
    if (!enableDropleadLink) {
      enablePageLink();
      return;
    }
    if (!validateDropleadPart1()) {
      return;
    }

    window.dataLayer.push({
      event: "facebook_event",
      trigger_type: "page view",
      position: "click next droplead npa details",
      fb_npa_list: fbNpaList,
    });
    
    kloader();
    sendDraft().then(() => {
      // recaptchaRef.current.reset();
      kloader();
      recaptchaRef.current?.reset();
    });
  }

  function goToFormPart2() {
    if (isMobile()) {
      $("#field-step-1").removeClass("current");
      $("#field-step-1").removeClass("current-reverse");
      $("#field-step-2").addClass("current");
    } else {
      $("#field-step-3").removeClass("current");
      $("#field-step-3").removeClass("current-reverse");
      $("#field-step-4").addClass("current");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#contact-desktop").offset().top - 65,
        },
        0
      );
    }
  }

  async function sendDraft() {
    var objRequest = {};

    try {
      recaptchaRef.current?.reset();
      const token = await recaptchaRef.current.executeAsync();
      objRequest.recapchaResult = token;
    } catch (error) {}

    console.log(recaptchaRef.current);

    console.log(objRequest);

    var userType = dropleadDetail.usertype.value;
    var interest = dropleadDetail.consentCheck.value;
    var utm_campaign = $("#utm_campaign").val() || "Organic";
    var utm_source = $("#utm_source").val() || "Organic";
    var utm_medium = $("#utm_medium").val() || "Organic";
    var utm_content = $("#utm_content").val() || "Organic";
    var utm_term = $("#utm_term").val() || "Organic";
    var e2e_bannerid = $("#e2e_bannerid").val() || "Organic";
    var pfsURL =
      getPathFromUrl(window.location.href) +
      (propertyDetail.PropertyID ? "?" + propertyDetail.PropertyID : "");

    var postPromise;

    if (userType === "normal") {
      var naCitizenIdVal = dropleadDetail.naCitizenId.value;

      postPromise = postApiDataAsync({
        urlPath: "/SubmitFormPart1_Personal",
        apiUrl: backendNPAURL,
        objRequest: {
          token: objRequest.recapchaResult,
          jwtData: window["generateToken"]({
            value01: dropleadDetail.phone.value,
            value02: dropleadDetail.email.value,
            value03: naCitizenIdVal,
            value04: dropleadDetail.consentCheck.value,
            value05: utm_campaign,
            value06: utm_source,
            value07: utm_medium,
            value08: utm_content,
            value09: utm_term,
            value10: e2e_bannerid,
            value11: propertyDetail.PropertyID,
            value12: pfsURL,
            value13: propertyDetail.SourceCode,
            value14: propertyDetail.PropertySourceName,
          }),
        },
      });
    } else {
      postPromise = postApiDataAsync({
        urlPath: "/SubmitFormPart1_Juristic",
        apiUrl: backendNPAURL,
        objRequest: {
          token: objRequest.recapchaResult,
          jwtData: window["generateToken"]({
            value01: dropleadDetail.juJuristicId.value,
            value02: dropleadDetail.juFirstName.value,
            value03: dropleadDetail.juLastName.value,
            value04: dropleadDetail.phone.value,
            value05: dropleadDetail.email.value,
            value06: dropleadDetail.consentCheck.value,
            value07: utm_campaign,
            value08: utm_source,
            value09: utm_medium,
            value10: utm_content,
            value11: utm_term,
            value12: e2e_bannerid,
            value13: propertyDetail.PropertyID,
            value14: pfsURL,
            value15: propertyDetail.SourceCode,
            value16: propertyDetail.PropertySourceName,
          }),
        },
      });
    }

    return postPromise.then(
      function (data) {
        if (data.HasCustomerInfo) {
          setHasCustomerInfo(data.HasCustomerInfo);
        }

        // if (hasCustomerInfo) {
        //     // $('.na-first-name-field, .na-last-name-field, .ju-company-name-field').hide();
        // } else {
        //     // $('.na-first-name-field, .na-last-name-field, .ju-company-name-field').show();
        // }

        goToFormPart2();

        dataLayer.push({
          event: "registrationComplete",
          eventCategory: "form_submit",
          eventAction: "success",
          eventLabel: "NPA2020_register_prefill",
          dimension40: userType === "ordinary" ? "บุคคลธรรมดา" : "นิติบุคคล", //นิติบุคคล,บุคคลธรรมดา
          dimension41: interest ? "Y" : "N", //สนใจทรัพย์สินรอการขาย
        });
      },
      function (err) {
        console.error(err);
        console.log(err.code);
        console.log(err.message);

        if (err.code === "DuplicateSubmitToday") {
          // $.alert({
          //     title: 'ขออภัย',
          //     content: 'หมายเลขบัตรประชาชนหรือ หมายเลขโทรศัพท์มือถือนี้ได้มีการลงทะเบียนไว้แล้ว กรุณารอเจ้าหน้าที่ติดต่อกลับภายใน 3 วันทำการ',
          // });
          openErrorPopup(
            "ขออภัย<br/>หมายเลขบัตรประชาชนหรือ หมายเลขโทรศัพท์มือถือนี้ได้มีการลงทะเบียนไว้แล้ว กรุณารอเจ้าหน้าที่ติดต่อกลับภายใน 3 วันทำการ"
          );
        } else if (err.code === "NetworkError") {
          // $.alert({
          //     title: 'ขออภัย',
          //     content: 'ไม่สามารถส่งข้อมูลได้ โปรดลองใหม่ในภายหลัง',
          // });
          openErrorPopup(
            "ขออภัย<br/>ไม่สามารถส่งข้อมูลได้ โปรดลองใหม่ในภายหลัง"
          );
        } else if (err.code === "InvalidCitizenID") {
          dispatch(
            DropleadValidateChange({
              field: "naCitizenId",
              errorMessage: "กรอกข้อมูลเลขบัตรประชาชนให้ถูกต้อง",
            })
          );
        } else if (err.code === "InvalidMobileNo") {
          dispatch(
            DropleadValidateChange({
              field: "phone",
              errorMessage: "กรอกข้อมูลเบอร์มือถือให้ถูกต้อง",
            })
          );
        } else if (err.code === "InvalidEmailAddress") {
          dispatch(
            DropleadValidateChange({
              field: "email",
              errorMessage: "กรอกข้อมูลอีเมลให้ถูกต้อง",
            })
          );
        } else if (err.code === "InvalidJuristicID") {
          dispatch(
            DropleadValidateChange({
              field: "juJuristicId",
              errorMessage: "กรอกข้อมูลเลขนิติบุคคลให้ถูกต้อง",
            })
          );
        } else if (err.code === "InvalidFirstName") {
          dispatch(
            DropleadValidateChange({
              field: "juFirstName",
              errorMessage: "กรอกข้อมูลชื่อให้ถูกต้อง",
            })
          );
        } else if (err.code === "InvalidLastName") {
          dispatch(
            DropleadValidateChange({
              field: "juLastName",
              errorMessage: "กรอกข้อมูลนามสกุลให้ถูกต้อง",
            })
          );
        } else {
          openErrorPopup(
            "ขออภัย<br/>ไม่สามารถดำเนินการได้ในขณะนี้ โปรดลองใหม่ในภายหลัง"
          );
        }
      }
    );
  }

  function dropLeadSubmit() {
    //applyFinishButtonHandler
    console.log("submit form part 2");

    if (!validateDropleadPart2()) {
      return;
    }

    kloader();

    var userType = dropleadDetail.usertype.value;
    var interest = dropleadDetail.consentCheck.value;
    var utm_campaign = $("#utm_campaign").val() || "Organic";
    var utm_source = $("#utm_source").val() || "Organic";
    var utm_medium = $("#utm_medium").val() || "Organic";
    var utm_content = $("#utm_content").val() || "Organic";
    var utm_term = $("#utm_term").val() || "Organic";
    var e2e_bannerid = $("#e2e_bannerid").val() || "Organic";
    var postPromise;

    if (userType === "normal") {
      var firstName;
      var lastName;
      var naSalary = +getAmount(dropleadDetail.naSalary.value);

      if (!hasCustomerInfo) {
        firstName = dropleadDetail.naFirstName.value;
        lastName = dropleadDetail.naLastName.value;
      } else {
        firstName = null;
        lastName = null;
      }

      postPromise = postApiDataAsync({
        urlPath: "/SubmitFormPart2_Personal",
        apiUrl: backendNPAURL,
        objRequest: {
          jwtData: window["generateToken"]({
            value01: dropleadDetail.phone.value,
            value02: dropleadDetail.email.value,
            value03: dropleadDetail.naCitizenId.value,
            value04: interest,
            value05: firstName,
            value06: lastName,
            value07: dropleadDetail.naCareer.value,
            value08: naSalary,
            value09: "", //form.find('#naProvince').val(),
            value10: "", //form.find('#naAmphoe').val(),
            value11: "", //form.find('#naBranch').val(),
            value12: dropleadDetail.availableTime.value,
            value13: utm_campaign,
            value14: utm_source,
            value15: utm_medium,
            value16: utm_content,
            value17: utm_term,
            value18: e2e_bannerid,
          }),
        },
      });
    } else {
      var companyName;

      if (!hasCustomerInfo) {
        companyName = dropleadDetail.juCompanyName.value;
      } else {
        companyName = null;
      }

      postPromise = postApiDataAsync({
        urlPath: "/SubmitFormPart2_Juristic",
        apiUrl: backendNPAURL,
        objRequest: {
          jwtData: window["generateToken"]({
            value01: dropleadDetail.juJuristicId.value,
            value02: dropleadDetail.juFirstName.value,
            value03: dropleadDetail.juLastName.value,
            value04: dropleadDetail.phone.value,
            value05: dropleadDetail.email.value,
            value06: interest,
            value07: companyName,
            value08: "", //form.find('#juProvince').val(),
            value09: "", //form.find('#juAmphoe').val(),
            value10: "", //form.find('#juBranch').val(),
            value11: dropleadDetail.availableTime.value,
            value12: utm_campaign,
            value13: utm_source,
            value14: utm_medium,
            value15: utm_content,
            value16: utm_term,
            value17: e2e_bannerid,
          }),
        },
      });
    }

    postPromise
      .then(
        function (data) {
          //stopLoader();

          //gotoThankyou();

          window.dataLayer.push({
            event: "facebook_event",
            trigger_type: "page view",
            position: "page load npa thank you",
            fb_npa_list: fbNpaList,
          });

          if (userType === "normal") {
            var naSalary = +getAmount(dropleadDetail.naSalary.value);
            dataLayer.push({
              event: "registrationComplete",
              eventCategory: "form_submit",
              eventAction: "success",
              eventLabel: "NPA2020_register_complete",
              dimension15: dropleadDetail.naCareer.value, //อาชีพ
              dimension5: naSalary, //รายได้ต่อเดือน
              dimension18: "", //จังหวัด
              dimension19: "", //เขต
              dimension20: "", //สาขา
              dimension21: dropleadDetail.availableTime.value, //เวลาที่สะดวกให้ติดต่อ
              eventCallback: function () {
                window.location.href =
                  "/th/PropertyForSale/property/droplead/Pages/thankyou.aspx";
              },
              eventTimeout: 1200,
            });
          } else {
            window.location.href =
              "/th/PropertyForSale/property/droplead/Pages/thankyou.aspx";
          }

          console.log("submit complete!");
        },
        function (err) {
          console.error(err);
          console.log(err.code);
          console.log(err.message);

          if (err.code === "DuplicateSubmitToday") {
            openErrorPopup(
              "หมายเลขบัตรประชาชนหรือ หมายเลขโทรศัพท์มือถือนี้ได้มีการลงทะเบียนไว้แล้ว กรุณารอเจ้าหน้าที่ติดต่อกลับภายใน 3 วันทำการ"
            );
          } else if (err.code === "NetworkError") {
            openErrorPopup("ไม่สามารถส่งข้อมูลได้ โปรดลองใหม่ในภายหลัง");
          } else if (err.code === "RowNotFound") {
            openErrorPopup(
              "ไม่สามารถบันทึกข้อมูลได้ โปรดเข้าหน้านี้ใหม่หรือกดปุ่ม refresh"
            );
          } else if (err.code === "UpdateNotAllowed") {
            openErrorPopup(
              "ไม่สามารถบันทึกข้อมูลได้ โปรดเข้าหน้านี้ใหม่หรือกดปุ่ม refresh"
            );
          } else {
            openErrorPopup(
              "ไม่สามารถดำเนินการได้ในขณะนี้ โปรดลองใหม่ในภายหลัง"
            );
          }
        }
      )
      .then(() => {
        kloader();
      });
  }

  function validateDropleadPart1() {
    let validateField = ["phone", "confirmphone", "email"];

    let juValidateField = ["juJuristicId", "juFirstName", "juLastName"];

    if (dropleadDetail.usertype.value === "ju") {
      validateField = validateField.concat(juValidateField);
    } else {
      validateField = validateField.concat(["naCitizenId"]);
    }

    const validates = validateField.map((field) => {
      const errorMessage = VaridateDropleadDataField(
        dropleadDetail,
        field,
        dropleadDetail[field].value
      );
      dispatch(DropleadValidateChange({ field, errorMessage })); //async (paraelle)
      const result = errorMessage === "";
      return result;
    });

    const valid = validates.every((c) => c);

    if (valid) {
      return true;
    }
    return false;
  }

  function validateDropleadPart2() {
    let validateField = ["availableTime"];

    let juValidateField = ["juCompanyName"];

    let normalValidateField = ["naCareer", "naSalary"];

    let normalValidateFieldNotHasCustomerInfo = ["naFirstName", "naLastName"];

    if (dropleadDetail.usertype.value === "ju" && !hasCustomerInfo) {
      validateField = validateField.concat(juValidateField);
    } else if (dropleadDetail.usertype.value === "normal") {
      validateField = validateField.concat(normalValidateField);
      if (!hasCustomerInfo) {
        validateField = validateField.concat(
          normalValidateFieldNotHasCustomerInfo
        );
      }
    }

    const validates = validateField.map((field) => {
      const errorMessage = VaridateDropleadDataField(
        dropleadDetail,
        field,
        dropleadDetail[field].value
      );
      dispatch(DropleadValidateChange({ field, errorMessage })); //async (paraelle)
      const result = errorMessage === "";
      return result;
    });

    const valid = validates.every((c) => c);

    if (valid) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (!$("#HiddenPreload").val()) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    console.log(params);
    kloader(true);
    var data = JSON.parse($("#HiddenPreload").val());
    // var data = Config.detailMockData;

    if (data) {
      initDetail(data);

      setFbNpaList([
        {
          content_id: data.PropertyID,
          content_type: "home_listing",
          property_type: getPropertyTypeEn(data),
          price: data.PromotionPrice || data.AdjustPrice || data.SellPrice,
        },
      ]);

      window.dataLayer.push({
        event: "facebook_event",
        trigger_type: "page view",
        position: "page load npa details",
        fb_npa_list: [
          {
            content_id: data.PropertyID,
            content_type: "home_listing",
            property_type: getPropertyTypeEn(data),
            price: data.PromotionPrice || data.AdjustPrice || data.SellPrice,
          },
        ],
      });

      $(".ft-phone a").on("click", function () {
        window.dataLayer.push({
          event: "facebook_event",
          trigger_type: "page view",
          position: "click call npa details",
          fb_npa_list: [
            {
              content_id: data.PropertyID,
              content_type: "home_listing",
              property_type: getPropertyTypeEn(data),
              price: data.PromotionPrice || data.AdjustPrice || data.SellPrice,
            },
          ],
        });
      });

      getApiDataAsync({
        urlPath: "/GetData",
        apiUrl: backendNPAURL,
      })
        .then(
          function (data) {
            console.log(data);

            var careerList = data.OccupationList.map(function (row) {
              return { text: row.Description, value: row.Description };
            });

            dispatch(
              DropleadListChange({ field: "naCareer", value: careerList })
            );

            var callbackPeriodList = data.ConvenientTimeList.map(function (
              row
            ) {
              return { text: row.Description, value: row.Description };
            });

            dispatch(
              DropleadListChange({
                field: "availableTime",
                value: callbackPeriodList,
              })
            );
          },
          function (err) {
            console.error(err);
            openErrorPopup("ไม่สามารถดึงข้อมูลได้ โปรดเข้าหน้านี้ใหม่");
          }
        )
        .then(() => {
          // setTimeout(function(){ initPageJs(); }, 1000);
        })
        .finally(() => {
          kloader(false);
        });
    } else {
      console.log("No Preload");
    }
  }, []);

  useEffect(() => {
    $(document).ready(function () {
      // Disable CSS
      $(
        'link[href*="/_catalogs/masterpage/KWeb2016/assets/css/style-en.css"]'
      ).attr("disabled", "disabled");
      $("#close-error-popup").on("click", function () {
        $("#error-popup").css({
          display: "",
        });
      });
    });
  }, []);

  useEffect(() => {
    let likeProperty = cookies["favoriteProperty"];

    if (!likeProperty || likeProperty == "undefined") {
      likeProperty = [];
    } else {
      likeProperty = likeProperty.split(",");
    }
    if (isLike && !likeProperty.includes(propertyDetail.PropertyID)) {
      whenSetCookie(
        "favoriteProperty",
        [...likeProperty, propertyDetail.PropertyID].filter((x) => x).join(",")
      );
    } else if (!isLike && likeProperty.includes(propertyDetail.PropertyID)) {
      whenSetCookie(
        "favoriteProperty",
        likeProperty.filter((x) => x !== propertyDetail.PropertyID).join(",")
      );
    }
    // console.log("favoriteProperty", propertyDetail.PropertyID)
    // whenSetCookie("favoriteProperty", propertyDetail.PropertyID)
  }, [isLike]);

  function initDetail(data) {
    console.log("data", data);
    tempDataDetail.PropertyMediaes = data.PropertyMediaes;

    tempDataDetail.PromotionPrice = data.PromotionPrice;
    tempDataDetail.hasSellPrice = data.hasSellPrice;

    tempDataDetail.PropertyTypeName = data.PropertyTypeName;
    //getPropertyType(data.PropertyTypeName)
    tempDataDetail.VillageTH = getValue(data.VillageTH);

    tempDataDetail.AssetInfoTH = getValue(data.AssetInfoTH);
    tempDataDetail.AddressNoTH = getValue(data.AddressNoTH);
    tempDataDetail.BuildingTH = getValue(data.BuildingTH);
    tempDataDetail.FloorTH = getValue(data.FloorTH);
    tempDataDetail.SoiTH = getValue(data.SoiTH);
    tempDataDetail.RoadTH = getValue(data.RoadTH);

    tempDataDetail.TambonName = getValue(data.TambonName);
    tempDataDetail.AmphurName = getValue(data.AmphurName);
    tempDataDetail.ProvinceName = getValue(data.ProvinceName);
    tempDataDetail.BuildingAge = getValue(data.BuildingAge);

    tempDataDetail.location = getLocation(tempDataDetail);

    tempDataDetail.Bedroom =
      showBedAndBath(data) && data.Bedroom > 0 ? data.Bedroom : "";
    tempDataDetail.Bathroom =
      showBedAndBath(data) && data.Bathroom > 0 ? data.Bathroom : "";

    tempDataDetail.TitlePageName = tempDataDetail.VillageTH
      ? tempDataDetail.VillageTH
      : `${getPropertyType(tempDataDetail)} ${tempDataDetail.ProvinceName}`;

    tempDataDetail.SellPrice = data.SellPrice;
    tempDataDetail.PromotionPrice = data.PromotionPrice;
    tempDataDetail.AdjustPrice = data.AdjustPrice;

    tempDataDetail.PromotionName = data.PromotionName;
    tempDataDetail.PromotionRemark = data.PromotionRemark;
    tempDataDetail.PropertyIDFormat = data.PropertyIDFormat;
    tempDataDetail.PropertyID = data.PropertyID;

    tempDataDetail.Area = data.Area;
    tempDataDetail.AreaValue = data.AreaValue;
    tempDataDetail.UseableArea = data.UseableArea;

    tempDataDetail.LinkLineChat = data.DataLineChat;

    var area = showAreaValue(data) ? getArea(data) : "";

    tempDataDetail.ShowAreaValue = area ? area.value + " " + area.unit : "";
    tempDataDetail.ShowUseableArea =
      showUseableAreaValue(data) && data.UseableArea
        ? data.UseableArea.toFixed(2) + " ตร.ม."
        : "";
    //showUseableAreaValue
    //showAreaValue

    tempDataDetail.PropertyMediaes = data.PropertyMediaes;
    tempDataDetail.GAScore = data.GAScore;
    tempDataDetail.IsHot = data.IsHot;
    tempDataDetail.GaCountView = data.GaCountView;
    tempDataDetail.IsNew = data.IsNew;
    tempDataDetail.SourceSaleType = data.SourceSaleType; // for check partner
    tempDataDetail.IsPartner = checkIsPartner(data);
    tempDataDetail.SourceImageLogo = data.SourceImageLogo;
    // tempDataDetail.Like =  at cookie below

    tempDataDetail.PromotionRemark = data.PromotionRemark;
    tempDataDetail.PMMaintenanceStatus = data.PMMaintenanceStatus;
    tempDataDetail.PropertySourceID = data.PropertySourceID;
    tempDataDetail.InOutProblemTH = data.InOutProblemTH;
    tempDataDetail.PropertySourceName = data.PropertySourceName;
    tempDataDetail.SourceCode = data.SourceCode;
    tempDataDetail.PropertyDocumentName = data.PropertyDocumentName;
    tempDataDetail.DocumentNo = data.DocumentNo;
    tempDataDetail.Latitude = data.Latitude;
    tempDataDetail.Longtitude = data.Longtitude;
    tempDataDetail.RemarkDetail = data.RemarkDetail;
    // PropertyMediaes   //video
    // NearbyPlaces
    // PropertiesInfoRelated

    tempDataDetail.NearbyPlaces = genNearByPlaces(data.NearbyPlaces);
    tempDataDetail.PropertiesInfoRelated = data.PropertiesInfoRelated;
    var tempDataDetailPropertiesInfoRelated =
      tempDataDetail.PropertiesInfoRelated?.sort((a, b) => {
        if (a.Distance < b.Distance) {
          return -1;
        }
        if (a.Distance > b.Distance) {
          return 1;
        }
        return 0;
      })
        ?.filter((x) => x.PropertyID.slice(2, 4) === "88")
        .slice(0, 15); // limit 15

    tempDataDetail.PropertiesInfoRelated = tempDataDetailPropertiesInfoRelated;

    tempDataDetail.PromotionStartDate = data.PromotionStartDate;
    tempDataDetail.PromotionEndDate = data.PromotionEndDate;
    tempDataDetail.PropertyIDPN = data.PropertyIDPN;

    // for AI
    tempDataDetail.CategoryGroup = data.CategoryGroup;
    tempDataDetail.CategoryDetail = data.CategoryDetail;
    tempDataDetail.AIImg = data.AIImg;
    tempDataDetail.isAuction = currentlyInAuction(data.PropertyID);

    dispatch(
      updateSearchResultList({
        fieldName: "suggestProperty",
        list: tempDataDetailPropertiesInfoRelated,
        hasMore: false,
      })
    );

    const likeProperty = cookies["favoriteProperty"];
    let recentlyviewedProperty = cookies["recentlyviewedProperty"];
    const PropertyID = data.PropertyID;
    if (!recentlyviewedProperty || recentlyviewedProperty == "undefined") {
      recentlyviewedProperty = [];
    } else {
      recentlyviewedProperty = recentlyviewedProperty.split(",");
    }
    if (cookies.Allow_Cookies === "N" && false) {
      dispatch(
        searchResultDataChange({ field: "Allow_Cookies", value: false })
      );
    } else {
      if (
        likeProperty &&
        likeProperty !== "undefined" &&
        likeProperty.includes(PropertyID)
      ) {
        tempDataDetail.Like = true;
      }
      if (!recentlyviewedProperty.includes(PropertyID)) {
        whenSetCookie(
          "recentlyviewedProperty",
          [...recentlyviewedProperty, PropertyID].filter((x) => x).join(",")
        );
      }
    }

    //For Calc
    $(function () {
      $("#calculate-result").hide();
      $("#calculate").on("click", function () {
        $(".container-calculate").removeClass("view-mode");
      });
    });

    const definePrice = data.PromotionPrice
      ? data.PromotionPrice
      : data.AdjustPrice
      ? data.AdjustPrice
      : data.SellPrice;
    dispatch(
      formsCalcDataChange({ field: "definedPropertyPrice", value: definePrice })
    );

    let appraisalPrice = data.KKApprovePrice;

    if (tempDataDetail.IsPartner && appraisalPrice === null) {
      appraisalPrice = definePrice;
      console.log("set appraisalPrice = definePrice");
    }

    console.log("appraisalPrice: " + appraisalPrice);

    dispatch(
      formsCalcDataChange({ field: "appraisalPrice", value: appraisalPrice })
    );
    dispatch(
      formsCalcDataChange({
        field: "calculatorHomeLoanSetting",
        value: getCalculatorSetting(data.CalculatorHomeLoanSetting),
      })
    );
    dispatch(
      formsCalcDataChange({
        field: "calculatorLandSetting",
        value: getCalculatorSetting(data.CalculatorLandSetting),
      })
    );
    dispatch(
      formsCalcDataChange({
        field: "calculatorSMESetting",
        value: getCalculatorSetting(data.CalculatorSMESetting),
      })
    );
    if (data.PropertyTypeName) {
      var propertyTypeID = data.PropertyTypeName.trim().split(" ")[0];

      dispatch(
        formsCalcDataChange({
          field: "propertyTypeID",
          value: propertyTypeID,
        })
      );

      // dispatch(
      //   formsCalcDataChange({
      //     field: "noDecoration",
      //     value: propertyTypeID.value === '01',
      //   })
      // );

      var appliedCalcTypes = getAppliedCalcTypes(
        propertyTypeID,
        data.AreaValue,
        calcDetail.calcTypes
      );

      console.log("appliedCalcTypes -->", appliedCalcTypes);

      dispatch(
        formsCalcDataChange({
          field: "appliedCalcTypes",
          value: appliedCalcTypes,
        })
      );
    }

    console.log("tempDataDetail -->", tempDataDetail);

    dispatch(updatePropertyDetail({ value: tempDataDetail }));
  }

  function getAppliedCalcTypes(propertyTypeID, areaValue, calcTypes) {
    var forStay = null;

    if (["02", "03", "04", "05"].indexOf(propertyTypeID) !== -1) {
      forStay = calcTypes.Home;
    } else if (
      propertyTypeID === "01" &&
      areaValue &&
      areaValue > 0 &&
      areaValue <= 4000
    ) {
      //empty land with size of 10 Rai or less
      forStay = calcTypes.Land;
    }

    var forBusiness = calcTypes.SME;

    return {
      forStay,
      forBusiness,
    };
  }

  function getCalculatorSetting(data) {
    var setting = {};
    var settingRow;

    for (var i = 0; i < data.length; i++) {
      settingRow = data[i];

      setting[settingRow.Code] = settingRow.Value;
    }

    return setting;
  }

  function whenSetCookie(name, value) {
    // console.log("when set cookie", cookies.Allow_Cookies)
    if (cookies.Allow_Cookies === "N" && false) {
      dispatch(
        searchResultDataChange({ field: "Allow_Cookies", value: false })
      );
    } else {
      setCookie(name, value, { path: "/" });
    }
  }

  window.openErrorPopup = openErrorPopup;

  function openErrorPopup(message) {
    $("#error-popup div div p").html(message);
    $("#error-popup").css({
      display: "flex",
    });
  }

  function closeErrorPopup() {
    $("#error-popup").css({
      display: "",
    });
  }

  function liveChatClick() {
    window.dataLayer.push({
      event: "facebook_event",
      trigger_type: "page view",
      position: "click live chat npa details",
      fb_npa_list: fbNpaList,
    });
  }

  return (
    <>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={ReCAPTCHASiteKey}
      />
      {/* <Header {...searchFilter} /> */}
      <HeaderWithSearch searchBtn={true} hideDesktop={true} />

      {/* Start New Packfile */}

      <Breadcrumbs {...propertyDetail} />

      <GallerySlide
        list={propertyDetail.PropertyMediaes}
        propertyName={propertyDetail.TitlePageName}
        propertyDetail={propertyDetail}
        makeAnOfferClick={makeAnOfferClick}
      />

      <section id="detail-content">
        <div className="container-1920">
          <div className="d-col-l">
            <AnnouncementText {...propertyDetail} />
            <TagBadgeWrapper {...propertyDetail} />
            <HeadingWrapper {...propertyDetail} />
            <PartnerDetail {...propertyDetail} />
            <PriceWrapper {...propertyDetail} />

            <div className="line-price-wrapper" />

            {/* <!-- Location --> */}
            <div className="location-container">
              <i className="ic-npa ic-npa-icon-pin"></i>
              <p>{propertyDetail.location}</p>
            </div>

            <TagPropertiesWrapper {...propertyDetail} />
            <DetailWrapper {...propertyDetail} />

            {propertyDetail.AIImg?.length > 0 && (
              <a
                href="#idea-decoration"
                className="ai-wrapper"
                title="ไอเดียแต่งห้อง ด้วย AI Room Generator"
                data-kbct="anchor_nav"
                data-kblb="idea_decoration"
                data-kbgp="decoration"
                data-kbsc="decoration"
                data-kbid={propertyDetail.PropertyID}
              >
                <div>
                  <img
                    width={26}
                    src="/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/img-detail/npa-icon-new.png"
                    alt="New icon"
                  />
                  <div className="ai-text-wrapper">
                    <p className="ai-title">ไอเดียแต่งห้องด้วย AI</p>
                    {/* <p className="ai-desc">ด้วย AI room generator</p> */}
                  </div>
                </div>
                <i className="ic-npa ic-npa-icon-arrow" />
              </a>
            )}
            <div className="line-table-detail" />

            <TableDetail {...propertyDetail} />

            <div className="mobile-contact-wrapper">
              {/* //contact-mobile-wrapper */}
              {propertyDetail.isAuction ? (
                <a
                  href={void 0}
                  onClick={makeAnOfferClick}
                  className="btn-link offer-btn mousePointer btn-green"
                  data-kbct="link_click"
                  data-kblb="offer"
                  data-kbgp="appointment"
                  data-kbsc="photo"
                  data-kbid={propertyDetail.PropertyID}
                >
                  ลงทะเบียนเข้าร่วมประมูล
                </a>
              ) : (
                <a
                  href={void 0}
                  onClick={makeAnOfferClick}
                  className="btn-link offer-btn mousePointer btn-green" //btn-green
                  data-kbct="link_click"
                  data-kblb="offer"
                  data-kbgp="appointment"
                  data-kbsc="photo"
                  data-kbid={propertyDetail.PropertyID}
                >
                  เสนอราคาซื้อ
                </a>
              )}
              <a
                href={void 0}
                className="btn-white"
                data-bs-toggle="offcanvas"
                data-bs-target="#contact-offcanvas"
                aria-controls="contact-offcanvas"
                data-kbct="open_popup"
                data-kblb="contact_staff"
                data-kbgp="appointment"
                data-kbsc="detail"
                data-kbid={propertyDetail.PropertyID}
              >
                ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์
              </a>
            </div>

            <PropertyNearByTabList2024 {...propertyDetail} addtion={"-lg"} />

            <div className="map-wrapper">
              {/* <MapContainer {...propertyDetail} /> */}
              {/* <div id="map-lg">
                                  <MyGoogleMap key="map2" {...propertyDetail} openErrorPopup={openErrorPopup} />
                              </div> */}
              <div id="map-lg" className="hide"></div>
              <div className="myMap">
                <MyGoogleMap
                  key="map2"
                  {...propertyDetail}
                  openErrorPopup={openErrorPopup}
                />
              </div>
            </div>

            <IdeaDecoration
              propertyDetail={propertyDetail}
              addtion={""}
              makeAnOfferClick={makeAnOfferClick}
            />

            {propertyDetail.IsPartner ? (
              <PartnerCalculator
                {...calcDetail}
                openErrorPopup={openErrorPopup}
                calcDetail={calcDetail}
                propertyId={propertyDetail.PropertyID}
              />
            ) : (
              <CalculatorsV2
                {...calcDetail}
                openErrorPopup={openErrorPopup}
                propertyId={propertyDetail.PropertyID}
              />
            )}

            <PropertyDetailsCondition {...propertyDetail} />

            <div className="property-info">
              <h2>ข้อมูลทรัพย์สิน</h2>
              <PropertyInfoTable {...propertyDetail} />
            </div>

            <PropertyRemark {...propertyDetail} />
          </div>
          <div className="d-col-r">
            <a
              href={propertyDetail.LinkLineChat}
              onClick={() => liveChatClick()}
              className="btn-chat px-getUTMXParams"
            >
              <i className="ic-npa ic-npa-icon-chat"></i>
              <span>Live Chat</span>
            </a>
            <div className="form-side">
              <div id="contact-desktop">
                <div id="contact" className="contact-form">
                  <h2>ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์</h2>
                  <p className="subtitle">
                    กรุณากรอกข้อมูลเพื่อให้เจ้าหน้าที่ติดต่อกลับ
                  </p>
                  <div className="usertype">
                    <div
                      className="usertype-box"
                      onClick={(e) => dropleadDataChange("usertype", "normal")}
                    >
                      <input
                        id="normal-lg"
                        type="radio"
                        name="usertype"
                        value="normal"
                        checked={dropleadDetail.usertype.value === "normal"}
                        hidden
                        readOnly
                      />
                      <label
                        htmlFor="normal-lg"
                        className={classnames([
                          {
                            AfterShowOpacity:
                              dropleadDetail.usertype.value === "normal",
                          },
                          "radio-box",
                        ])}
                      ></label>
                      <label htmlFor="normal-lg" className="radio-text">
                        บุคคลธรรมดา
                      </label>
                    </div>
                    <div
                      className="usertype-box"
                      onClick={(e) => dropleadDataChange("usertype", "ju")}
                    >
                      <input
                        id="entity-lg"
                        type="radio"
                        name="usertype"
                        value="legal entity"
                        checked={dropleadDetail.usertype.value === "ju"}
                        hidden
                        readOnly
                      />
                      <label
                        htmlFor="entity-lg"
                        className={classnames([
                          {
                            AfterShowOpacity:
                              dropleadDetail.usertype.value === "ju",
                          },
                          "radio-box",
                        ])}
                      ></label>
                      <label htmlFor="entity-lg" className="radio-text">
                        นิติบุคคล
                      </label>
                    </div>
                  </div>

                  {/* <!-- Step 1 --> */}
                  <div id="field-step-3" className="field-step current">
                    <div className="field-item">
                      {dropleadDetail.usertype.value === "ju" && (
                        <div>
                          <DropLeadInputField
                            {...dropleadDetail.juJuristicId}
                            OnformsDataChange={dropleadDataChange}
                            formsBlur={dropleadBlur}
                          />
                          <DropLeadInputField
                            {...dropleadDetail.juFirstName}
                            OnformsDataChange={dropleadDataChange}
                            formsBlur={dropleadBlur}
                          />
                          <DropLeadInputField
                            {...dropleadDetail.juLastName}
                            OnformsDataChange={dropleadDataChange}
                            formsBlur={dropleadBlur}
                          />
                        </div>
                      )}

                      <DropLeadInputField
                        {...dropleadDetail.phone}
                        OnformsDataChange={dropleadDataChange}
                        formsBlur={dropleadBlur}
                      />
                      <DropLeadInputField
                        {...dropleadDetail.confirmphone}
                        OnformsDataChange={dropleadDataChange}
                        formsBlur={dropleadBlur}
                      />
                      <DropLeadInputField
                        {...dropleadDetail.email}
                        OnformsDataChange={dropleadDataChange}
                        formsBlur={dropleadBlur}
                      />
                      {showNaCitizenId && (
                        <div>
                          <DropLeadInputField
                            {...dropleadDetail.naCitizenId}
                            OnformsDataChange={dropleadDataChange}
                            formsBlur={dropleadBlur}
                          />
                        </div>
                      )}
                    </div>
                    <div className="field-item">
                      <div
                        className="consent-group"
                        onClick={(e) => {
                          e.preventDefault();
                          dropleadDataChange(
                            "consentCheck",
                            !dropleadDetail.consentCheck.value
                          );
                        }}
                      >
                        <input
                          id="consent-check-lg"
                          type="checkbox"
                          name="consent-check"
                          hidden
                          checked={dropleadDetail.consentCheck.value}
                          readOnly
                        />
                        <label
                          htmlFor="consent-check-lg"
                          className={classnames([
                            {
                              AfterShowOpacity:
                                dropleadDetail.consentCheck.value,
                            },
                            "check-box",
                          ])}
                        ></label>
                        <label
                          htmlFor="consent-check-lg"
                          className="check-text"
                        >
                          สนใจสินเชื่อทรัพย์มือสอง
                        </label>
                      </div>
                      <PrivacyText {...propertyDetail} />
                    </div>
                    <div className="btn-confirm">
                      <button
                        type="button"
                        className="btn-main btn-first"
                        onClick={dropLeadDraft}
                      >
                        ถัดไป
                      </button>
                    </div>
                    <div className="my-2">
                      <p
                        className="privacy-text text-center"
                        style={{ fontSize: "12px" }}
                      >
                        This site is protected by reCAPTCHA <br />
                        and the Google <a href={void 0}>
                          Privacy Policy
                        </a> and <a href={void 0}>Terms of Service</a> apply.
                      </p>
                    </div>
                  </div>

                  {/* <!-- Step 2 --> */}
                  <div id="field-step-4" className="field-step">
                    {dropleadDetail.usertype.value === "ju" &&
                      !hasCustomerInfo && (
                        <div>
                          <DropLeadInputField
                            {...dropleadDetail.juCompanyName}
                            OnformsDataChange={dropleadDataChange}
                            formsBlur={dropleadBlur}
                          />
                        </div>
                      )}

                    {dropleadDetail.usertype.value === "normal" && (
                      <div>
                        {!hasCustomerInfo && (
                          <>
                            <DropLeadInputField
                              {...dropleadDetail.naFirstName}
                              OnformsDataChange={dropleadDataChange}
                              formsBlur={dropleadBlur}
                            />
                            <DropLeadInputField
                              {...dropleadDetail.naLastName}
                              OnformsDataChange={dropleadDataChange}
                              formsBlur={dropleadBlur}
                            />
                          </>
                        )}
                        <DropLeadSelectList
                          {...dropleadDetail.naCareer}
                          OnformsDataChange={dropleadDataChange}
                        />
                        <DropLeadInputField
                          {...dropleadDetail.naSalary}
                          OnformsDataChange={dropleadDataChange}
                          formsBlur={dropleadBlur}
                        />
                      </div>
                    )}
                    <DropLeadSelectList
                      {...dropleadDetail.availableTime}
                      OnformsDataChange={dropleadDataChange}
                    />
                    <div className="btn-confirm">
                      <button
                        type="button"
                        className="btn-main btn-first"
                        onClick={dropLeadSubmit}
                      >
                        ส่งข้อมูล
                      </button>
                    </div>
                    <div>
                      <button
                        id="field-prev-lg"
                        type="button"
                        className="back-btn"
                        onClick={dropleadDesktopBack}
                      >
                        <i className="ic-npa ic-npa-icon-back"></i>
                        ย้อนกลับ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {propertyDetail.isAuction ? (
              <div className="offer-wrapper">
                <h2>สนใจประมูลทรัพย์สิน</h2>
                <a
                  href={void 0}
                  onClick={makeAnOfferClick}
                  className="offer-btn mousePointer "
                  data-kbct="link_click"
                  data-kblb="offer"
                  data-kbgp="appointment"
                  data-kbsc="photo"
                  data-kbid={propertyDetail.PropertyID}
                >
                  ลงทะเบียนเข้าร่วมประมูล
                </a>
                <div className="a-center">
                  <a href={auctionDetailLink}>ดูรายละเอียดเพิ่มเติม</a>
                </div>
              </div>
            ) : (
              <div className="offer-wrapper">
                {enableOfferLink ? (
                  <>
                    <h2>เสนอราคาซื้อทรัพย์สิน</h2>
                    <a
                      href={void 0}
                      onClick={makeAnOfferClick}
                      className="offer-btn mousePointer "
                      data-kbct="link_click"
                      data-kblb="offer"
                      data-kbgp="appointment"
                      data-kbsc="photo"
                      data-kbid={propertyDetail.PropertyID}
                    >
                      เสนอราคาซื้อ
                    </a>
                  </>
                ) : (
                  <>
                    <span className="c-red remark-h2">
                      การเสนอซื้อราคาซื้อทรัพย์สิน
                      <br />
                      อยู่ระหว่างการปรับปรุงระบบ
                    </span>
                    <br
                      style={{
                        /* lineHeight: 4, */
                        display: "block",
                        margin: "10px 0",
                        content: '" "',
                      }}
                    />
                    <span className="remark-h3">
                      ไม่สามารถใช้งานได้เป็นการชั่วคราว
                    </span>
                    <br />
                    <span className="remark-text">
                      และจะเปิดให้ทำรายการอีกครั้ง
                      <br />
                      วันที่{" "}
                      {moment(closePageEndTime).locale("th").format("LLL")} น.
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* End New Packfile */}

      <div className="pagebreak"></div>

      <div className="pagebreak"></div>

      {/* <!-- Fixed bar bottom --> */}
      {isMobile() && (
        <div id="fixed-bar-bottom" className="fixed-bar-bottom">
          {/* <button type="button" className="btn-main btn-third" onClick={makeAnOfferClick}>
          เสนอราคาซื้อ
        </button> */}
          <button
            className="btn-main btn-first"
            data-bs-toggle="offcanvas"
            data-bs-target="#contact-offcanvas"
            aria-controls="contact-offcanvas"
            data-kbct="open_popup"
            data-kblb="contact_staff"
            data-kbgp="appointment"
            data-kbsc="detail"
            data-kbid={propertyDetail.PropertyID}
          >
            ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์
          </button>
          <a
            href={propertyDetail.LinkLineChat}
            onClick={() => liveChatClick()}
            className="btn-main btn-other chat px-getUTMXParams"
            data-kbct="chatbox"
            data-kblb="line_chat"
            data-kbgp="contact"
            data-kbid={propertyDetail.PropertyID}
          >
            <i className="ic-npa ic-npa-icon-chat" />
          </a>
          <button
            className="btn-main btn-other other"
            data-bs-toggle="offcanvas"
            data-bs-target="#other-offcanvas"
            aria-controls="other-offcanvas"
          >
            <i
              className="ic-npa ic-npa-icon-other"
              data-kbct="open_popup"
              data-kblb="more_action"
              data-kbgp="detail"
              data-kbsc="more_action"
            />
          </button>
        </div>
      )}

      {/* <!-- Gallery Modal -->
            <div id="gallery-modal" className="gallery-backdrop">
                <div className="swiper gallery-modal-swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img src="/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/gallery-1.jpg" alt="Gallery" />
                        </div>
                        <div className="swiper-slide">
                            <img src="/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/gallery-2.jpg" alt="Gallery" />
                        </div>
                        <div className="swiper-slide">
                            <img src="/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/gallery-3.jpg" alt="Gallery" />
                        </div>
                    </div>
                    <div title="Next" className="slick-bt-next swiper-button-next next-btn"></div>
                    <div  title="Previous" className="slick-bt-back swiper-button-prev prev-btn"></div>
                    <div className="swiper-pagination fraction"></div>
                    <button type="button" className="close-gallery-modal">
                        <img src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg" alt="" />
                    </button>
                </div>
            </div> */}

      {/* <!-- ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์  --> */}
      <div
        className="offcanvas offcanvas-bottom contact-offcanvas no-print"
        tabIndex="-1"
        id="contact-offcanvas"
      >
        <div className="offcanvas-header">
          <h2 className="offcanvas-title">
            ติดต่อเจ้าหน้าที่ / <br /> นัดหมายเข้าชมทรัพย์
          </h2>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <h4 className="">กรุณากรอกข้อมูลเพื่อให้เจ้าหน้าที่ติดต่อกลับ</h4>
          <div id="contact-mobile">
            <div className="usertype">
              <div
                className="usertype-box"
                onClick={(e) => dropleadDataChange("usertype", "normal")}
              >
                <input
                  id="normal"
                  type="radio"
                  name="usertype"
                  value="normal"
                  checked={dropleadDetail.usertype.value === "normal"}
                  hidden
                  readOnly
                />
                <label
                  htmlFor="normal"
                  className={classnames([
                    {
                      AfterShowOpacity:
                        dropleadDetail.usertype.value === "normal",
                    },
                    "radio-box",
                  ])}
                ></label>
                <label htmlFor="normal" className="radio-text">
                  บุคคลธรรมดา
                </label>
              </div>
              <div
                className="usertype-box"
                onClick={(e) => dropleadDataChange("usertype", "ju")}
              >
                <input
                  id="entity"
                  type="radio"
                  name="usertype"
                  value="legal entity"
                  checked={dropleadDetail.usertype.value === "ju"}
                  hidden
                  readOnly
                />
                <label
                  htmlFor="entity"
                  className={classnames([
                    {
                      AfterShowOpacity: dropleadDetail.usertype.value === "ju",
                    },
                    "radio-box",
                  ])}
                ></label>
                <label htmlFor="entity" className="radio-text">
                  นิติบุคคล
                </label>
              </div>
            </div>
            {/* <!-- Step 1 --> */}
            <div id="field-step-1" className="field-step current">
              <div className="field-item">
                {dropleadDetail.usertype.value === "ju" && (
                  <div>
                    <DropLeadInputField
                      {...dropleadDetail.juJuristicId}
                      OnformsDataChange={dropleadDataChange}
                      formsBlur={dropleadBlur}
                    />
                    <DropLeadInputField
                      {...dropleadDetail.juFirstName}
                      OnformsDataChange={dropleadDataChange}
                      formsBlur={dropleadBlur}
                    />
                    <DropLeadInputField
                      {...dropleadDetail.juLastName}
                      OnformsDataChange={dropleadDataChange}
                      formsBlur={dropleadBlur}
                    />
                  </div>
                )}

                <DropLeadInputField
                  {...dropleadDetail.phone}
                  OnformsDataChange={dropleadDataChange}
                  formsBlur={dropleadBlur}
                />
                <DropLeadInputField
                  {...dropleadDetail.confirmphone}
                  OnformsDataChange={dropleadDataChange}
                  formsBlur={dropleadBlur}
                />
                <DropLeadInputField
                  {...dropleadDetail.email}
                  OnformsDataChange={dropleadDataChange}
                  formsBlur={dropleadBlur}
                />
                {showNaCitizenId && (
                  <div>
                    <DropLeadInputField
                      {...dropleadDetail.naCitizenId}
                      OnformsDataChange={dropleadDataChange}
                      formsBlur={dropleadBlur}
                    />
                  </div>
                )}
              </div>
              <div className="field-item">
                <div
                  className="consent-group"
                  onClick={(e) => {
                    e.preventDefault();
                    dropleadDataChange(
                      "consentCheck",
                      !dropleadDetail.consentCheck.value
                    );
                  }}
                >
                  <input
                    id="consent-check"
                    type="checkbox"
                    name="consent-check"
                    hidden
                    checked={dropleadDetail.consentCheck.value}
                    readOnly
                  />
                  <label
                    htmlFor="consent-check"
                    className={classnames([
                      { AfterShowOpacity: dropleadDetail.consentCheck.value },
                      "check-box",
                    ])}
                  ></label>
                  <label htmlFor="consent-check" className="check-text">
                    สนใจสินเชื่อทรัพย์มือสอง
                  </label>
                </div>
                <PrivacyText {...propertyDetail} />
              </div>
              <div className="btn-confirm">
                <button
                  type="button"
                  className="btn-main btn-first"
                  onClick={dropLeadDraft}
                >
                  ถัดไป
                </button>
              </div>
              <div className="my-2">
                <p
                  className="privacy-text text-center"
                  style={{ fontSize: "12px" }}
                >
                  This site is protected by reCAPTCHA <br />
                  and the Google <a href={void 0}>Privacy Policy</a> and{" "}
                  <a href={void 0}>Terms of Service</a> apply.
                </p>
              </div>
            </div>

            {/* <!-- Step 2 --> */}
            <div id="field-step-2" className="field-step">
              {dropleadDetail.usertype.value === "ju" && !hasCustomerInfo && (
                <div>
                  <DropLeadInputField
                    {...dropleadDetail.juCompanyName}
                    OnformsDataChange={dropleadDataChange}
                    formsBlur={dropleadBlur}
                  />
                </div>
              )}

              {dropleadDetail.usertype.value === "normal" && (
                <div>
                  {!hasCustomerInfo && (
                    <>
                      <DropLeadInputField
                        {...dropleadDetail.naFirstName}
                        OnformsDataChange={dropleadDataChange}
                        formsBlur={dropleadBlur}
                      />
                      <DropLeadInputField
                        {...dropleadDetail.naLastName}
                        OnformsDataChange={dropleadDataChange}
                        formsBlur={dropleadBlur}
                      />
                    </>
                  )}
                  <DropLeadSelectList
                    {...dropleadDetail.naCareer}
                    OnformsDataChange={dropleadDataChange}
                  />
                  <DropLeadInputField
                    {...dropleadDetail.naSalary}
                    OnformsDataChange={dropleadDataChange}
                    formsBlur={dropleadBlur}
                  />
                </div>
              )}
              <DropLeadSelectList
                {...dropleadDetail.availableTime}
                OnformsDataChange={dropleadDataChange}
              />
              <div className="btn-confirm">
                <button
                  type="button"
                  className="btn-main btn-first"
                  onClick={dropLeadSubmit}
                >
                  ส่งข้อมูล
                </button>
              </div>
              <div>
                <button
                  type="button"
                  id="normal-field-prev"
                  className="back-btn"
                  onClick={dropleadMobileBack}
                >
                  <i className="ic-npa ic-npa-icon-back"></i>
                  ย้อนกลับ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- ยืนยัน --> */}
      <div id="confirm-data-modal" className="form-backdrop">
        <div className="form-modal">
          <img
            className="close-form-modal"
            src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-black.svg"
            alt="Close modal"
            onClick={cancelMakeAnOffer}
          />
          <div className="content">
            <i className="ic-npa ic-npa-icon-confirmfile"></i>
            <h5>ต้องการยืนยันการเสนอซื้อ</h5>
          </div>
          <div className="form-modal-btn">
            <button
              id="cancel"
              type="button"
              name="cancel"
              className="btn-main btn-cancel"
              onClick={cancelMakeAnOffer}
            >
              ยกเลิก
            </button>
            <button
              type="button"
              className="btn-main btn-first"
              onClick={makeAnOffer}
            >
              ยืนยัน
            </button>
          </div>
        </div>
      </div>

      {/* <!-- แชร์  --> */}
      <ShareConent />

      {/* <!-- ตัวเลือกเพิ่มเติม  --> */}
      <div
        className="offcanvas offcanvas-bottom other-offcanvas"
        tabIndex="-1"
        id="other-offcanvas"
      >
        <div className="offcanvas-header">
          <h2 className="offcanvas-title">ตัวเลือกเพิ่มเติม</h2>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="d-flex justify-content-center align-items-start">
            <a
              href="#calculators"
              className="offcanvas-card-link"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              data-kbct="anchor_nav"
              data-kblb="calculate"
              data-kbgp="detail"
              data-kbsc="more_action"
            >
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-cal"></i>
              </div>
              คำนวณ
              <br />
              สินเชื่อ
            </a>
            <a
              href={void 0}
              className="offcanvas-card-link"
              data-bs-toggle="offcanvas"
              data-bs-target="#shared-offcanvas-2"
              aria-controls="offcanvasBottom"
              data-kbct="open_popup"
              data-kblb="main_link"
              data-kbgp="social_share"
              data-kbsc="detail"
            >
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-share"></i>
              </div>
              ส่งต่อให้เพื่อน
            </a>
            <a
              href="javascript:void(0)"
              onClick={likeThisProperty}
              className="offcanvas-card-link"
              data-kbct="click"
              data-kblb="favorite"
              data-kbgp="detail"
              data-kbsc="more_action"
              data-kbid={propertyDetail.PropertyID}
            >
              <div
                className={classnames([
                  { active: isLike },
                  "offcanvas-card like-offcanvas",
                ])}
              >
                <i
                  className={classnames([
                    { "ic-npa-icon-like-active": isLike },
                    { "ic-npa-icon-like": !isLike },
                    "ic-npa",
                  ])}
                ></i>
              </div>
              ทรัพย์ถูกใจ
            </a>
            <a
              href={pagesLink.printDetail.replace(
                "{{PropID}}",
                propertyDetail.PropertyID
              )}
              className="offcanvas-card-link"
              target="_blank"
              data-kbct="link_click"
              data-kblb="printer"
              data-kbgp="detail"
              data-kbsc="more_action"
            >
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-print" />
              </div>
              พิมพ์
            </a>
          </div>
        </div>
      </div>

      {/* <!-- Popup Error Message --> */}
      <div id="error-popup" className="popup-error-backdrop">
        <div className="popup-modal">
          <button
            type="button"
            id="close-error-popup"
            onClick={(e) => closeErrorPopup()}
            className="more-filter-btn error"
          >
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
              alt="Close modal"
            />
          </button>
          <div className="popup-inner">
            <p>
              ภาระหนี้ที่ระบุต้องไม่เกิน 108,100 บาท หรือเพิ่มรายได้ต่อเดือน
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const SuggestPart = () => {
  const [suggestProperty] = useSelector((state) => [
    state.property.searchResult.suggestProperty,
  ]);

  function htmlEntities(s) {
    return s.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
      return "&#" + i.charCodeAt(0) + ";";
    });
  }

  if (!suggestProperty.list || suggestProperty.list.length === 0) {
    return <></>;
  }

  return (
    <>
      <section id="property-nearby" className="nearLocation-container">
        <h2>ทรัพย์ใกล้เคียง</h2>
        <div className="swiper assets-swiper">
          <PropertyList list={suggestProperty.list} />
          <div className="swiper-pagination scroll-pagi assets-pagi-1"></div>
        </div>
        <div
          title="Next"
          className="slick-bt-next swiper-button-next next-btn asset-next"
        ></div>
        <div
          title="Previous"
          className="slick-bt-back swiper-button-prev prev-btn asset-prev"
        ></div>
      </section>
    </>
  );
};

function initPageJs() {
  console.log("initPageJs run");
  var gl1 = $(".gallery-swiper").data("swp");
  if (gl1) gl1.destroy();

  var gallerySwiper = new Swiper(".gallery-swiper", {
    slidesPerView: "auto",
    initialSlide: 1,
    spaceBetween: 10,
    centeredSlides: true,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(".gallery-swiper").data("swp", gallerySwiper);

  var gl2 = $(".gallery-sm-swiper").data("swp");
  if (gl2) gl2.destroy();

  var gallerySmSwiper = new Swiper(".gallery-sm-swiper", {
    slidesPerView: "auto",
    initialSlide: 1,
    spaceBetween: 10,
    loop: false,
    pagination: {
      el: ".gallery-sm-pagi",
      clickable: true,
    },
    noSwipingClass: "gallery-sm-more",
    threshold: 20,
  });

  $(".gallery-sm-swiper").data("swp", gallerySmSwiper);

  var galleryModalSwiper = new Swiper(".gallery-modal-swiper", {
    zoom: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: false,
      type: "custom",
      renderCustom: function (swiper, current, total) {
        console.log(current + "/" + total);
        return current + "/" + total;
      },
    },
  });

  //suggest
  var assetSwiper1 = new Swiper(".assets-swiper", {
    slidesPerView: "auto",
    freeMode: true,
    spaceBetween: 20,
    breakpoints: {
      1025: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    pagination: {
      el: ".assets-pagi-1",
      clickable: true,
    },
    navigation: {
      nextEl: ".asset-next",
      prevEl: ".asset-prev",
    },
  });

  gallerySwiper.on("slideChange", function () {
    var currentIndex = gallerySwiper.realIndex;
    var galleryList = $(".gallery-sm-swiper .swiper-slide");
    $(galleryList).removeClass("active");
    $(galleryList[currentIndex]).addClass("active");
    gallerySmSwiper.slideTo(currentIndex);
  });

  var galleryList = $(".gallery-sm-swiper .swiper-slide");
  $(galleryList).each(function (idx, el) {
    $(el)
      .off("click")
      .on("click", function () {
        if (idx != galleryList.length - 1) {
          gallerySwiper.slideToLoop(idx);
        }
      });
  });

  $(".more-gallery-btn").on("click", function () {
    $("#gallery-modal").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  $(".close-gallery-modal").on("click", function () {
    $("#gallery-modal").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(".gallery-swiper .swiper-slide").on("click", function () {
    const index = $(this).attr("data-swiper-slide-index");

    var galleryModalSwiper = new Swiper(".gallery-modal-swiper", {
      zoom: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
        type: "custom",
        renderCustom: function (swiper, current, total) {
          console.log(current + "/" + total);
          return current + "/" + total;
        },
      },
    });

    galleryModalSwiper.slideTo(index, false, false);

    $("#gallery-modal").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  window.dispatchEvent(new Event("resize"));

  document.querySelectorAll(".tab-facility  a").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "Tab Content",
        event_action: "click",
        event_label:
          "สถานที่ใกล้เคียง_" +
          e.target.closest(".nav-link").getAttribute("data-bs-target"),
      });
    });
  });

  //promotion detail
  document.querySelectorAll("#promotions a").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "link_click",
        event_action: "click",
        event_label: e.target.getAttribute("alt"),
      });
    });
  });

  //[property nearby click]
  document.querySelectorAll("#property-nearby a").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "link_click",
        event_action: "click",
        event_label:
          "ทรัพย์ใกล้เคียง_" +
          e.target
            .closest("a")
            .querySelector(".md-thumbnail-detail .asset-code").innerText,
      });
    });
  });

  //form abandonment droplead
  var historyFormNPA = [];
  window.addEventListener(
    "beforeunload",
    function () {
      if (
        historyFormNPA.length &&
        dataLayer.filter((x) => x.eventLabel === "NPA2020_register_complete")
          .length === 0
      ) {
        window.dataLayer.push({
          event: "formAbandonment",
          eventCategory: "Form Abandonment",
          eventAction: historyFormNPA.join(" > "),
        });
      }
    },
    { once: true }
  );

  //form abandonment calculator
  var historyFormAbandonment = [];
  window.addEventListener(
    "beforeunload",
    function () {
      if (
        historyFormAbandonment.length &&
        dataLayer.filter((x) => x.event === "submitCalculator").length === 0
      ) {
        window.dataLayer.push({
          event: "formAbandonment",
          eventCategory: "Form Abandonment_Calculator",
          eventAction: historyFormAbandonment.join(" > "),
        });
      }
    },
    { once: true }
  );

  document
    .querySelectorAll(
      ".calculate-group .select2-selection.select2-selection--single,.calculate-group input"
    )
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        historyFormAbandonment.push(e.target.getAttribute("id"));
      });
    });

  document
    .querySelectorAll(".field-item .form-item input")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        historyFormNPA.push(
          e.target.closest(".form-item").querySelector("label").innerText
        );
      });
    });

  //like btn
  document.querySelectorAll(".social-btn.like-btn").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "NPA-DETAIL-2022",
        event_action: "click",
        event_label: "ถูกใจ",
      });
    });
  });
  //popup picture
  document.querySelectorAll(".more-gallery-btn").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "pop-up",
        event_action: "click",
        event_label: "ดูรูปทั้งหมด",
      });
    });
  });
  //close popup picture
  document.querySelectorAll(".close-gallery-modal").forEach(function (item) {
    item.addEventListener("click", function (e) {
      dataLayer.push({
        event: "track_event",
        event_category: "pop-up",
        event_action: "click",
        event_label: "Close",
      });
    });
  });
  //share email
  document
    .querySelectorAll(".d-flex.justify-content-center.align-items-center")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "social_share",
          event_action: "click",
          event_label: "Share Email",
        });
      });
    });
}

function dropleadDesktopBack(e) {
  $("#field-step-3").addClass("current-reverse");
  $("#field-step-4").removeClass("current");
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $("#contact-desktop").offset().top - 65,
    },
    0
  );
}

function dropleadMobileBack() {
  $("#field-step-1").addClass("current-reverse");
  $("#field-step-2").removeClass("current");
}

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <DetailPage />
    </Provider>
  </CookiesProvider>,
  document.getElementById("react-app-detail")
);
ReactDOM.render(
  <Provider store={store}>
    <SuggestPart />
    <LoginFooter />
  </Provider>,
  document.getElementById("react-app-detail-suggest")
);

console.log("react app property detail start");
